import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import { loadPlugin } from "../plugins/vue-socket-io";
Vue.use(VueRouter);

const Home = () => import("../views/Home.vue");
const Studio = () => import("../views/Studio.vue");
const Profile = () => import("../views/Profile.vue");
const Legal = () => import("../views/Legal.vue");
const Tools = () => import("../views/Tools.vue");
const Test = () => import("../views/Test.vue");
const StudioManager = () => import("../views/StudioManager.vue");
const ScriptBuilder = () => import("../views/ScriptBuilder.vue");
const Pricing = () => import("../views/Pricing.vue");
const ReportManager = () => import("../views/ReportManager.vue");
const EventManager = () => import("../views/EventManager.vue");
const EventRegistration = () => import("../views/EventRegistration.vue");
const EventSignupComplete = () => import("../views/EventSignupComplete.vue");
const EventJoin = () => import("../views/EventJoin.vue");
const EventCalendar = () => import("../views/EventCalendar.vue");

const routes: Array<RouteConfig> = [
    {
        path: "/",
        name: "Home",
        component: Home,
        meta: { title: "VIBRIX Online-Präsentationsplattform" },
    },
    {
        path: "/studio/:studioId",
        name: "Studio",
        component: Studio,
        props: true,
        beforeEnter(to, from, next) {
            loadPlugin();
            next();
        },
        meta: { title: "VIBRIX Studio" },
    },
    {
        path: "/studio/:studioId/:registrationId",
        name: "Event Studio",
        component: Studio,
        props: true,
        beforeEnter(to, from, next) {
            loadPlugin();
            next();
        },
        meta: { title: "VIBRIX Event Studio" },
    },
    {
        path: "/script",
        name: "Script",
        component: ScriptBuilder,
        meta: { title: "VIBRIX Script Manager" },
    },
    {
        path: "/profile",
        name: "Profile",
        component: Profile,
        meta: { title: "Profile" },
    },
    {
        path: "/legal",
        name: "Legal",
        component: Legal,
        meta: { title: "Legal" },
    },
    {
        path: "/tools",
        name: "Tools",
        component: Tools,
        meta: { title: "VIBRIX Tools" },
    },
    {
        path: "/test",
        name: "Test",
        component: Test,
        meta: { title: "VIBRIX Test" },
    },
    {
        path: "/studios",
        name: "Studio Manager",
        component: StudioManager,
        meta: { title: "VIBRIX Studio Manager" },
    },
    {
        path: "/pricing",
        name: "Pricing",
        component: Pricing,
        meta: { title: "VIBRIX Pricing" },
    },
    {
        path: "/reports",
        name: "Report Manager",
        component: ReportManager,
        meta: { title: "VIBRIX Report Manager" },
    },
    {
        path: "/events",
        name: "Event Manager",
        component: EventManager,
        meta: { title: "VIBRIX Event Manager" },
    },
    {
        path: "/events/registration",
        name: "Event Registration",
        component: EventRegistration,
        meta: { title: "VIBRIX Event Registration" },
        props: route => ({
            eventId: route.query.eventId,
            email: route.query.email,
            source: route.query.s,
        }),
    },
    {
        path: "/events/registration/complete/:registrationId",
        name: "Event Registration Complete",
        component: EventSignupComplete,
        meta: { title: "VIBRIX Event Signup Complete" },
        props: true,
    },
    {
        path: "/events/join/:registrationId",
        name: "Event Join",
        component: EventJoin,
        meta: { title: "VIBRIX Event Join" },
        props: true,
    },
    {
        path: "/events/calendar/:userId/:ym",
        name: "Event Calendar",
        component: EventCalendar,
        props: true,
        meta: { title: "Event Calendar" },
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior: to => {
        if (to.hash) {
            return { selector: to.hash };
        } else {
            return { x: 0, y: 0 };
        }
    },
});

const DEFAULT_TITLE = "VIBRIX Presentation Platform";
router.afterEach(to => {
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

function getRoutesList(routes: Array<RouteConfig>, pre: string) {
    return routes.reduce((array: Array<string>, route) => {
        const path = `${pre}${route.path}`;

        if (route.path !== "*") {
            array.push(path);
        }

        if (route.children) {
            array.push(...getRoutesList(route.children, `${path}/`));
        }

        return array;
    }, []);
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getRoutesXML() {
    const list = getRoutesList(routes, "https://vibrix.net")
        .map(
            route =>
                `<url><loc>${route}</loc><lastmod>2020-11-20</lastmod></url>`
        )
        .join("\r\n");
    return `<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9" xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" xsi:schemaLocation="http://www.sitemaps.org/schemas/sitemap/0.9 http://www.sitemaps.org/schemas/sitemap/0.9/sitemap.xsd">
      ${list}
    </urlset>`;
}
// console.log(getRoutesXML());

export default router;
